var Alberta = "Alberta";
var Manitoba = "Manitoba";
var Nunavut = "Nunavut";
var Ontario = "Ontario";
var Quebec = "Quebec";
var Saskatchewan = "Saskatchewan";
var Yukon = "Yukon";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "British Columbia",
	Manitoba: Manitoba,
	"New Brunswick": "New Brunswick",
	"Newfoundland and Labrador": "Newfoundland and Labrador",
	"Northwest Territories": "Northwest Territories",
	"Nova Scotia": "Nova Scotia",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "Prince Edward Island",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
